// extracted by mini-css-extract-plugin
module.exports = {"carouselBackground":"MobileCarousel_carouselBackground__PqR3I","car":"MobileCarousel_car__2_WH_","carouselItem":"MobileCarousel_carouselItem__F-eT7"};